import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";
import ControlledInput from "../CustomInput/ControlledInput";

function DateFilter(props) {
  const [value, setValue] = useState(props[props.fieldKey]?.value);

  useEffect(() => {
    if (value !== props[props.fieldKey]?.unparsedValue) {
      setValue(props[props.fieldKey]?.unparsedValue);
    }
  }, [props[props.fieldKey]]);

  return (
    <ControlledInput
      InputProps={props.InputProps}
      controlled={false}
      nullable={true}
      onHandleValue={(value) => {
        setValue(value);

        let parsedValue = value;
        if (props.parseValue) {
          parsedValue = props.parseValue(value);
        }

        if (!parsedValue) {
          props.setFilter(props.fieldKey, null);
        } else {
          props.setFilter(props.fieldKey, {
            field: props.field ?? props.fieldKey,
            operator: props.operator,
            value: parsedValue,
            unparsedValue: value,
          });
        }
      }}
      type={"date"}
      value={value}
    />
  );
}

DateFilter.propTypes = {
  placeholder: PropTypes.string,
  fieldKey: PropTypes.string.isRequired,
  field: PropTypes.string,
  operator: PropTypes.string,
  InputProps: PropTypes.object,
  parseValue: PropTypes.func,
};

DateFilter.defaultProps = {
  operator: "=",
  InputProps: {},
};

const mapStateToProps = (state, props) => ({
  [props.fieldKey]: state.filtersV2[props.fieldKey],
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(DateFilter, productenStyle));
